import React from 'react'
import Navbar from '../../common/Navbar'
import Footer from '../../common/Footer'
import MainPage from './MainPage'
const Main = () => {
  return (
    <div>
        <Navbar />
  <MainPage/>
        <Footer/>

    </div>
  )
}

export default Main